/**
 * website change of 2019-06-17
 */
class ModifyTime20190617 {
  constructor () {
    this._tmp = $('#mobileNavChange20190617')
    this._el = null
    this.$mobileMenu20190617 = null
    this.isOpen = false;
    this.init()
  }
  
  init () {
    set_quote();
    function set_quote(){
      var quote_num = $('blockquote').length;
      // console.log(quote_num);
      if(quote_num){
        for (var i = 0; i < quote_num; i++) {
          var ele_num = document.getElementsByTagName('blockquote')[i].children.length;
          var p_text_first  = document.getElementsByTagName('blockquote')[i].firstElementChild.innerText;
          var p_text  = document.getElementsByTagName('blockquote')[i].children[ele_num-1].innerText;
          // console.log(p_text_first);
          
          // p_text_first = '「'+'  '+ p_text_first;
          // console.log(p_text_first);
          if(window._siteLang == "zh-hk"){

            p_text = p_text+'  '+'」';
          }else{
            p_text = p_text+'  '+'"';

          }
          // document.getElementsByTagName('blockquote')[i].firstElementChild.innerText =p_text_first;
          document.getElementsByTagName('blockquote')[i].children[ele_num-1].innerText =p_text;
          
        }
      }
    }
    

    // 190929 add font-size  start
      let dNum = 1
      let fontSizeBtn = $('.a-font-size')
      let font_h2 = $('.entry-content>h2') //引导语
      let fontEle = $('.entry-content.clearfix')// 正文
      let font_pic = $('.entry-content .wp-caption-text')//图片标题
      let smallBtn = fontSizeBtn.children('.js-font-size-small')
      let bigBtn = fontSizeBtn.children('.js-font-size-big')
      
      
      //引导语
      window.defaultFontSize_h2 = parseInt(font_h2.css('fontSize'))
      window.maxFontSize_h2 = window.defaultFontSize_h2 + 3
      window.minFontSize_h2 = window.defaultFontSize_h2 - 3
      
      // 正文
      let odefaultFontSize =  window.defaultFontSize = parseInt(fontEle.css('fontSize'))
      window.maxFontSize = window.defaultFontSize + 6
      window.minFontSize = window.defaultFontSize - 3

      //图片标题
      let odefaultFontSize_pic =  parseInt(font_pic.css('fontSize'))
      window.defaultFontSize_pic =  parseInt(font_pic.css('fontSize'))
      window.maxFontSize_pic = window.defaultFontSize_pic + 6
      window.minFontSize_pic = window.defaultFontSize_pic - 3
      

      smallBtn.on('click', () => {
        window.defaultFontSize_h2 -= dNum
        window.defaultFontSize_h2 = window.defaultFontSize_h2 < window.minFontSize_h2 ? window.minFontSize_h2 : window.defaultFontSize_h2
        font_h2.css('fontSize', window.defaultFontSize_h2)

        let ochange = window.defaultFontSize <= odefaultFontSize ? 1 : 2
        window.defaultFontSize -= ochange
        window.defaultFontSize = window.defaultFontSize < window.minFontSize ? window.minFontSize : window.defaultFontSize
        fontEle.css('fontSize', window.defaultFontSize)
        
        let ochange_pic = window.defaultFontSize_pic <= odefaultFontSize_pic ? 1 : 2
        window.defaultFontSize_pic -= ochange_pic
        window.defaultFontSize_pic = window.defaultFontSize_pic < window.minFontSize_pic ? window.minFontSize_pic : window.defaultFontSize_pic
        font_pic.css('fontSize', window.defaultFontSize_pic)
      })
      
      bigBtn.on('click', () => {
        window.defaultFontSize_h2 += dNum
        window.defaultFontSize_h2 = window.defaultFontSize_h2 > window.maxFontSize_h2 ? window.maxFontSize_h2 : window.defaultFontSize_h2
        font_h2.css('fontSize', window.defaultFontSize_h2)


        let ochange = window.defaultFontSize < odefaultFontSize ? 1 : 2
        window.defaultFontSize += ochange
        window.defaultFontSize = window.defaultFontSize > window.maxFontSize ? window.maxFontSize : window.defaultFontSize
        fontEle.css('fontSize', window.defaultFontSize)

        let ochange_pic = window.defaultFontSize_pic < odefaultFontSize_pic ? 1 : 2
        window.defaultFontSize_pic += ochange_pic
        window.defaultFontSize_pic = window.defaultFontSize_pic > window.maxFontSize_pic ? window.maxFontSize_pic : window.defaultFontSize_pic
        font_pic.css('fontSize', window.defaultFontSize_pic)
      })

    // 190929 add font-size  end



    

    //  add svg icon from lang
    $('.menuMobileBox__btn--lang').append(`
    <span class="dashicons dashicons-no-alt"></span>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"/></svg>
    `)
    //  add site title
    $('.menuMobileBox__item--left').after(`<h1 class="site-title">${$('.site-title').eq(0).html()}</h1>`)
    //  create mobile menu
    if (this._tmp.length > 0) {
      this._el = $('<div/>')
      this._el.html(this._tmp.html())
      
      this._createMobileMenu()
      this.$mobileMenu20190617 = $('.mobileMenu20190617')
      
      this._mobileMenuEventHandle()
      
      $(window).on('menuClick', ev => this._menuClickEventHandle())
      $(window).resize(() => {
        if (window.innerWidth >= 1024) {
          this.menuClose()
          this._langEntriesMobileHide()
        }
        this.calcMenuHeight()
      })
    }
    
    if ($('#languageEntries').length > 0) {
      //  add lang entries in mobile
      this._langEntriesMobile()
    }
    this._createOverlay();
  }
  
  /**
   * add lang entries in mobile
   * @private
   */
  _langEntriesMobile () {
    let langsBtn = $('.menuMobileBox__btn--lang')
    $('.site-inner .content-sidebar-wrap').append(`<section class="languageEntriesBoxMobile">${$('#languageEntries').html()}</section>`)
    
    langsBtn.on('click', ev => {
      if (langsBtn.hasClass('langsOpen')) {
        this._langEntriesMobileHide()
      } else {
        this._langEntriesMobileShow()
      }
    })
  }
  
  _langEntriesMobileHide () {
    let section = $('.languageEntriesBoxMobile')
    
    section.removeClass('langsOpen')
    $('.menuMobileBox__btn--lang').removeClass('langsOpen')
    document.body.classList.remove('mobileMenuOpen')
    this.close()
  }
  
  _langEntriesMobileShow () {
    let section = $('.languageEntriesBoxMobile')
    this.menuClose()
    
    //  计算高度
    this.calcMenuHeight()
    $('.menuMobileBox__btn--lang').addClass('langsOpen')
    section.addClass('langsOpen')
    document.body.classList.add('mobileMenuOpen')
    this.open();
  }

  /**
   * menu click event handle
   * @private
   */
  _menuClickEventHandle () {
    $('.menuMobileBox__btn--menu').toggleClass('menuOpenIcon')
    if (this.$mobileMenu20190617.hasClass('menuOpen')) {
      this.menuClose()
    } else {
      this.menuOpen()
    }
  }
  
  menuClose () {
    $('.menuMobileBox__btn--menu').removeClass('menuOpenIcon')
    this.$mobileMenu20190617.removeClass('menuOpen')
    document.body.classList.remove('mobileMenuOpen')
    this.close()
  }
  
  menuOpen () {
    this._langEntriesMobileHide()
  
    //  计算高度
    this.calcMenuHeight()
    this.$mobileMenu20190617.addClass('menuOpen')
    document.body.classList.add('mobileMenuOpen')
    this.open();
    //  实现定位
    if ($('.current-menu-item').length > 0) {
      let currentMenuId = $('.current-menu-item').get(0).id
      
      $(`.menuBox #${currentMenuId}`).addClass('current-menu-item')
    }
  }

  calcMenuHeight () {
    let height = $(window).height() - $('.site-container').offset().top
    this.$mobileMenu20190617.css('height', `${height}px`)
    $('.languageEntriesBoxMobile').css('height', `${height}px`)
  }
  
  //  create mobile menu
  _createMobileMenu () {
    //  create el
    let el = $(`<section class="mobileMenu20190617"></section>`)
    
    //  add social icon
    el.append(`<div class="a2a_kit a2a_kit_size_27 a2a_follow">${this._el.find('.socialIcon').html()}</div>`)
    
    //  add subscribe and donate btn
    el.append(`<div class="secondBtnBox">${this._el.find('.buttons').html()}</div>`)
    
    //  add menu
    el.append(`<div class="menuBox">${$('#menu-main').html()}</div>`)
    
    //  add download app btn
    el.append(`<div class="thirdBtnBox">${this._el.find('.downloadBtn').html()}</div>`)
    
    $('.site-inner').append(el)
  }
  
  /**
   * mobile menu event handle
   * @private
   */
  _mobileMenuEventHandle () {
    $('.menuBox .menu-item-has-children').append(`<button class="menuArrow"><span class="icon-cheveron-up"></span></button>`)
    
    $('.menuBox .menuArrow').on('click', ev => {
      let currentTarget = $(ev.currentTarget)
      let parent = currentTarget.parent()
      
      $('.menuBox .childrenOpen').map((key, el) => {
        if (el.id != parent.attr('id')) {
          el.classList.remove('childrenOpen')
        }
      })
      
      $(ev.currentTarget).parent().toggleClass('childrenOpen')

    })
  }

  /**
   *
   * @private
   */
  _createOverlay() {
    let overlay = document.createElement('div');
    this._closeBound = this.close.bind(this);
    overlay.classList.add('sidenav-overlay');

    overlay.addEventListener('click', this._closeBound);

    document.body.appendChild(overlay);
    this._overlay = overlay;
  }


  open() {
    if (this.isOpen === true) {
      return;
    }

    this.isOpen = true;
    $(this._overlay).css({
      display: 'block',
      opacity: 1
    });

  }

  close() {
    if (this.isOpen === false) {
      return;
    }
    this.isOpen = false;
    this._overlay.style.display = 'none';
    this.menuClose()
    this._langEntriesMobileHide()

  
  }
  

}

export default ModifyTime20190617
